/* eslint-disable sonarjs/cognitive-complexity */
import React, { useMemo, useState } from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Affix, Col, Row } from 'antd';
import { Form, Select } from 'formik-antd';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';
import { Box, FormInput, CustomInput, Button } from 'atoms';
import { Debug } from '../Debug';
import { updateVendor } from 'store/vendorSlice';
import { gstRegType } from 'utils/config';
// import { useQuery } from 'hooks';
import { ACL, BoxMod, EditModeBtn, ImageView } from 'components/common';
import FilesUploadS3 from 'components/common/FilesUploadS3';
import { pdfimgfiletypetoShow, pdfimgformates } from 'utils';
import { CancelButton } from 'utils/commonStyled';
export default function DocumentInfoForm({ isEditMode = false, formData = {}, otherFormsData }) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	// const [query] = useQuery();
	const [panFilesList, setPanFilesList] = useState([]);
	const [aadharFilesList, setAadharFilesList] = useState([]);
	const [gstFilesList, setGstFilesList] = useState([]);
	const [editMode, setEditMode] = useState(false);

	// eslint-disable-next-line react-hooks/exhaustive-deps
	const FormSchema = useMemo(() =>
		Yup.object({
			pan_number: Yup.string()
				.required()
				.min(10)
				.max(25)
				.label('Pan Number')
				.matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, 'Please enter valid Pan Number'),
			gst_reg_type: Yup.string().required().label('GSt reg type'),
			aadhar_number: Yup.string()
				.min(12)
				.max(12)
				.label('Aadhar number')
				.matches(/^[0-9]*$/, 'Please enter valid Aadhar number'),
			gst_number: Yup.string()
				.min(15)
				.max(15)
				.label('GST number')
				.matches(/^[a-zA-Z0-9]*$/, 'Please enter valid GST number')
				.when('reporting_time', (gst_reg_type, schema) => {
					if (gst_reg_type === 'registered') return schema.required();
					return schema;
				}),
		})
	);

	const initialValues = useMemo(
		() => ({
			pan_number: formData?.pan_number || undefined,
			gst_reg_type: formData?.gst_reg_type || undefined,
			aadhar_number: formData?.aadhar_number || undefined,
			gst_number: formData?.gst_number || undefined,
		}),
		[formData]
	);

	const handleSubmit = (values, { setErrors, setSubmitting }) => {
		const payload = {
			...otherFormsData,
			document_info: {
				...values,
				pan_doc: !isEmpty(panFilesList) ? panFilesList : formData?.pan_doc,
				aadhar_doc: !isEmpty(aadharFilesList) ? aadharFilesList : formData?.aadhar_doc,
				gst_doc: !isEmpty(gstFilesList) ? gstFilesList : formData?.gst_doc,
			},
		};

		if (isEditMode) {
			payload.update_type = 'vendor';
		} else {
			payload.create_type = 'vendor';
		}
		dispatch(updateVendor({ req_data: payload, setErrors, isEditMode }))
			.then((res) => {
				setSubmitting(false);
				window.location = `${window.origin}/vendors/${res.data.id}?tab=4`;
			})
			.catch(() => {
				setSubmitting(false);
			});
	};

	function handlePanFileUpload(files) {
		console.log('handlePanFileUpload', files);
		setPanFilesList(files);
	}
	function handleAadharFileUpload(files) {
		console.log('handleAadharFileUpload', files);
		setAadharFilesList(files);
	}
	function handleGstFileUpload(files) {
		console.log('handleGstFileUpload', files);
		setGstFilesList(files);
	}
	function handleEdit() {
		setEditMode(!editMode);
	}
	return (
		<Formik
			initialValues={initialValues}
			validationSchema={FormSchema}
			onSubmit={handleSubmit}
			enableReinitialize
		>
			{() => (
				<>
					<ACL action="update" module="vendor">
						{isEditMode && <EditModeBtn handleEdit={handleEdit} />}
					</ACL>
					<Form className={editMode === false ? 'disabled-div' : ''}>
						{otherFormsData?.vendor_type === 'temporary' && (
							<Affix offsetTop={10}>
								<Box
									background="red"
									padding="5px"
									color="#fff"
									fontSize="20px"
									marginTop="6px"
								>
									{' '}
									Note: Please fill All section data if its temporary Vendor{' '}
								</Box>
							</Affix>
						)}
						<Box padding="1.5rem 2rem" background="#fff">
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="pan_number" label="PAN Number *">
										<CustomInput name="pan_number" isCaps />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="gst_reg_type" label="GST Reg Type *">
										<Select
											name="gst_reg_type"
											filterOption={(input, option) =>
												option.label
													.toLowerCase()
													.indexOf(input.toLowerCase()) >= 0
											}
											placeholder="Select"
											options={gstRegType}
										/>
									</FormInput>
								</Col>
							</Row>
							<Row gutter={16} justify="space-between">
								<Col lg={12}>
									<FormInput name="aadhar_number" label="Aadhar Number">
										<CustomInput name="aadhar_number" />
									</FormInput>
								</Col>
								<Col lg={12}>
									<FormInput name="gst_number" label="GST Number">
										<CustomInput name="gst_number" />
									</FormInput>
								</Col>
							</Row>
						</Box>
						<BoxMod></BoxMod>
						<Box border="1px solid #ccc" padding="34px">
							<FilesUploadS3
								entity="vendor"
								successCallBack={handlePanFileUpload}
								name="PAN document"
								size={5120000}
								fileformates={pdfimgformates}
								filetypetoShow={pdfimgfiletypetoShow}
							/>
							<Box backgroundColor="#fff" textAlign="right" padding="1.5rem"></Box>
							{panFilesList && (
								<ImageView
									entity="vendor"
									files={formData?.pan_doc}
									name="PAN Document"
								/>
							)}
						</Box>
						<BoxMod></BoxMod>
						<Box border="1px solid #ccc" padding="34px">
							<FilesUploadS3
								entity="vendor"
								successCallBack={handleAadharFileUpload}
								name="Aadhar document"
								size={5120000}
								fileformates={pdfimgformates}
								filetypetoShow={pdfimgfiletypetoShow}
							/>
							<Box backgroundColor="#fff" textAlign="right" padding="1.5rem"></Box>
							{aadharFilesList && (
								<ImageView
									entity="vendor"
									files={formData?.aadhar_doc}
									name="AAdhar Document"
								/>
							)}
						</Box>
						<BoxMod></BoxMod>
						<Box border="1px solid #ccc" padding="34px">
							<FilesUploadS3
								entity="vendor"
								successCallBack={handleGstFileUpload}
								name="GST document"
								size={5120000}
								fileformates={pdfimgformates}
								filetypetoShow={pdfimgfiletypetoShow}
							/>
							<Box backgroundColor="#fff" textAlign="right" padding="1.5rem"></Box>
							{gstFilesList && (
								<ImageView
									entity="vendor"
									files={formData?.gst_doc}
									name="GST Document"
								/>
							)}
						</Box>

						<Box backgroundColor="#f5f5f5" textAlign="right" padding="1.5rem">
							<CancelButton onClick={() => navigate('/vendor-list')} type="button">
								Cancel
							</CancelButton>
							<Button borderRadius="4px" backgroundColor="#18405d" type="submit">
								{isEditMode ? 'Update' : 'Submit'}
							</Button>
						</Box>
						<Debug />
					</Form>
				</>
			)}
		</Formik>
	);
}

DocumentInfoForm.propTypes = {
	isEditMode: PropTypes.bool,
	formData: PropTypes.object,
	otherFormsData: PropTypes.object,
};
